import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import profileP from "../Images/profile-pic.png";
import NotificationModal from "../Component/Modal/NotificationModal";
import toast from "react-hot-toast";
import HomeService from "../Services/HomeService";
import Swal from "sweetalert2";

const Header = () => {
  const [profileData, setProfileData] = useState("");
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const userRole = localStorage.getItem("role");
  const [notificationmodal, setNotificationmodal] = useState(false);
  const notificationModal = () => {
    setNotificationmodal(true);
  };

  const [Searchmodal, setSearchmodal] = useState(false);
  const responSearch = () => {
    setSearchmodal(!Searchmodal);
  };

  const ShowSidebar = () => {
    if (document.querySelector("#responsiveMenu").click) {
      document.querySelector(".sidebarwrap").classList.add("show");
    } else {
      document.querySelector(".sidebarwrap").classList.remove("show");
    }
  };
  const HideSidebar = () => {
    document.querySelector(".sidebarwrap").classList.remove("show");
  };
  // >>>>Fetch Admin Login Data<<<<
  // const fetchAdminLoginData = async () => {
  //   const res = await HomeService.getLoginProfile();
  //   // console.log("this is login profile data", res);

  //   if (res && res?.status) {
  //     setProfileData(res?.data)
  //   }
  // }

  // >>>Handle Admin Logout<<<
  // const handleLogOut = () => {
  //   toast.success("Logout SuccessFull");
  //   localStorage.clear();
  //   navigate("/login");
  // };

  const handleLogOut = async () => {
    const result = await Swal.fire({
      title: "Logout Data Entry Operator?",
      text: "Are you sure you want to Log Out",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Log Out!",
      confirmButtonColor: "#d33",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    });
    if (result.isConfirmed) {
      // try {
      //   await deleteState(id);
      //   Swal.fire("Deleted!", "City has been deleted.", "success");
      //   fetchStates();
      // } catch (error) {
      //   Swal.fire("Error!", "Failed to delete city.", "error");
      // }
      localStorage.clear();
      toast.success("Logout SuccessFull");
      Swal.fire("Logged Out Successfully!", "success");
      navigate("/login");
    }
  };

  useEffect(() => {
    // fetchAdminLoginData();
  }, []);
  return (
    <>
      <section className="mainheader_sec">
        <button
          className="responsive_menu"
          id="responsiveMenu"
          onClick={ShowSidebar}
        >
          <i className="fa-solid fa-bars"></i>
        </button>
        <button className="responsSearch_btn" onClick={responSearch}>
          <i className="fa-solid fa-magnifying-glass"></i>
        </button>

        <div className=" sales_admin_div">
          <h3
            style={{
              textTransform: "capitalize",
            }}
          >
            {/* {userRole !== "superadmin" ? userRole : "Super"} */}
            Data Entry Operator
          </h3>
          <i class="fa-solid fa-angle-left fa-rotate-270"></i>
          <div>
            <button
              style={{ backgroundColor: "#3a6348" }}
              className="btn btn-primary"
              onClick={() => {
                handleLogOut();
              }}
            >
              Logout
            </button>
          </div>
        </div>

        {/* <div className="right_header_div_wrapper">
          <div className="search_input_wrapper">
            <input type="text" placeholder="Search..." />
            <i className="fa-solid fa-search"></i>
          </div>
          <div className="new_product_wrapper_div_head">
            <div className="small_circle_div">
              <i class="fa-solid fa-envelope"></i>
            </div>
            <div className="small_circle_div">
              <i class="fa-solid fa-star"></i>
            </div>
            <div className="add_new_product_input_wrapper">
              <p>Add New Product</p>
              <i className="fa-solid fa-plus"></i>
            </div>
          </div>
        </div> */}
      </section>

      {Searchmodal && (
        <div className="responsiveSearch_box">
          <form className="form-inline">
            <input
              className="form-control"
              type="search"
              placeholder="Search here...."
              aria-label="Search"
            />
            <button
              className="Search_icon"
              type="submit"
              onClick={() => setSearchmodal(false)}
            >
              <i className="fa-solid fa-magnifying-glass"></i>
            </button>
          </form>
        </div>
      )}

      {notificationmodal && (
        <NotificationModal closeModal={setNotificationmodal} />
      )}

      <Sidebar HideSidebar={HideSidebar} />
    </>
  );
};

export default Header;
